import { useEffect, useState } from 'react';

import { IJobPost, IPageResult } from 'common/models';
import { PostedJobManagementServices } from 'admin/services';
import { useAlert } from 'common/hooks';

export const usePostedJobs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [queryOptions, setQueryOptions] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });
  const [jobPostResults, setJobPostResults] = useState<IPageResult<IJobPost>>({
    data: [],
    total: 0,
  });

  const { onAlert } = useAlert();

  useEffect(() => {
    const queryParams = new URLSearchParams({
      page: (paginationModel.page + 1).toString(),
      pageSize: paginationModel.pageSize.toString(),
      ...queryOptions,
    });
    setIsLoading(true);
    PostedJobManagementServices.getJobPosts(queryParams.toString())
      .then((res) => setJobPostResults(res))
      .catch((err) =>
        onAlert(err?.message || 'Failed to fetch Job posts', 'error')
      )
      .finally(() => setIsLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel.page, paginationModel.pageSize, queryOptions]); // TO DO use react query

  return {
    isLoadingPostedJobs: isLoading,
    jobPostResults,
    paginationModel,
    setPaginationModel,
    setQueryOptions,
  };
};
